module.exports = __webpack_public_path__ + "static/plan1-d63241b0aeb178bc40e21c4d7abe7520.png";